import api from './api';

const promocionService = {
  // Obtener todas las promociones (solo admin)
  getAllPromociones: async () => {
    try {
      const response = await api.get('/api/promotions/admin/all');
      return response.data;
    } catch (error) {
      console.error('Error al obtener promociones:', error);
      throw error;
    }
  },

  // Activar/desactivar promoción (solo admin)
  togglePromocionEstado: async (id, estado) => {
    try {
      const response = await api.put(`/api/promotions/${id}/status`, { 
        promotionId: id,
        status: estado 
      });
      return response.data;
    } catch (error) {
      console.error(`Error al cambiar estado de promoción con ID ${id}:`, error);
      throw error;
    }
  },

  // Eliminar una promoción (solo admin)
  deletePromocion: async (id) => {
    try {
      const response = await api.delete(`/api/Promotions/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar promoción con ID ${id}:`, error);
      throw error;
    }
  }
};

export default promocionService;
